import { render, staticRenderFns } from "./HRShift.vue?vue&type=template&id=23aeaeda&scoped=true&"
import script from "./HRShift.vue?vue&type=script&lang=js&"
export * from "./HRShift.vue?vue&type=script&lang=js&"
import style0 from "./HRShift.vue?vue&type=style&index=0&id=23aeaeda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aeaeda",
  null
  
)

export default component.exports